import React, { useEffect, useState } from "react";
import API from "util/Api";
import SnackBar from "components/SnackBar";
import ContainerHeader from "components/ContainerHeader";
import _ from "lodash";
import * as Yup from "yup";
import ActionsTable from "components/ActionsTable/TableList";
import EZForm, { getFieldValues } from "components/EZForm";

const VisitorGuard = (props) => {
    const [config, setConfig] = useState();
    const [guardTable, setGuardTable] = useState();
    const [fieldValues, setFieldValues] = useState();
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });

    const validations = Yup.object().shape({
        first_name: Yup.string().required("Required"),
        email: Yup.string().required("Required"),
        location: Yup.object().required("Required")
    });

    useEffect(() => {
        API.get("visitorGuard")
            .then((res) => {
                setConfig(res.data.data.config);
                setGuardTable(res.data.data.table);
            })
            .catch((err) => {
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    }, []);

    const handleSubmit = (data, form) => {
        API.post("visitorGuard", JSON.stringify(data))
            .then((res) => {
                setGuardTable(res.data.data);
                form.setSubmitting(false);
                form.resetForm();
                setSnackBar({
                    open: true,
                    message: res.data.msg,
                    type: "success",
                });
            })
            .catch((err) => {
                console.log("error", err);
                form.setSubmitting(false);
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    };

    const handleEdit = (clickedLoc) => {
        setFieldValues(getFieldValues(Object.values(clickedLoc)));
        // scroll to top
        document.body.style.height = "auto";
        setTimeout(function () {
            document.body.style.height = "100%";
        }, 50);
    };

    return (
        config &&
        <>
            <ContainerHeader title={config?.title} match={props.match} />
            <EZForm
                fields={Object.values(config.fields)}
                values={fieldValues}
                validationSchema={validations}
                onSubmit={handleSubmit}
            />
            {guardTable && (
                <ActionsTable
                    tableHeading={guardTable.title}
                    table={guardTable}
                    onEdit={handleEdit}
                    actions={true}
                />
            )}
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar(prevState => ({ ...prevState, open: false, message: "" }));
                }}
            />
        </>
    )
}
export default VisitorGuard;